import { InjectionToken } from '@angular/core';
import type { ImageSize } from 'libs/shared-lib/interfaces/ui/m000-c010-image.interface';

export const M060C010VehicleCardStyleToyota: M060C010VehicleCardStyleData = {
    brandName: 'TOYOTA',
    container: 'bg-light-bg h-full',
    image: 'h-240 min-w-350 xs:min-w-365 md:min-w-480 lg:min-w-338 w-full object-cover',
    imageSizes: {
        desktop: { width: 360, height: 240 },
        tablet: { width: 360, height: 240 },
        moblie: { width: 360, height: 240 },
    },
    div: 'py-16 px-16',
    headline: 'font-semibold text-18 text-light-text',
    modelTypeText: 'mt-3 mb-24 text-12',
    badgeContainer: 'flex flex-wrap gap-8',
    badgeWrapper: 'bg-grey-100',
    badge: 'text-light-text text-10 px-10 py-4 leading-14 tracking-0.1',
    actionTag: 'gap-8 mt-8 mb-16',
    divider: 'border-b border-accent w-full max-w-75p',
    dividerDark: '',
    nextArrow: {
        container: 'hidden lg:flex left-md w-40 h-40 bg-light-bg shadow-sm justify-center items-center',
        color: 'fill-light-text',
        size: '!w-40 !h-40',
    },
    prevArrow: {
        container: 'hidden lg:flex left-md w-40 h-40 bg-light-bg shadow-sm justify-center items-center',
        color: 'fill-light-text',
        size: '!w-40 !h-40',
    },
    efficiency: '',
    consumptionAndEmission: 'text-grey-400 text-10 leading-14 tracking-0.25 mt-8',
    seller: {
        copy: 'text-grey-400 text-10 leading-14 tracking-0.25 ml-6',
        iconPath: 'assets/icons/location.svg',
        iconStyle: 'fill-grey-400 w-9 h-11',
    },
    skeleton: {
        headline: 'h-27 w-100 bg-grey-100',
        modelTypeText: 'mt-3 mb-24 h-18 w-100 bg-grey-100',
        priceValueDark: 'bg-light-bg',
        priceValueLight: 'bg-dark-bg',
        priceContainerDark: 'bg-dark-bg',
        priceContainerLight: 'bg-light-bg',
    },
    hardselling: {
        tag: 'bg-white-90 pr-5 pt-2 pb-4',
        topVehicle: {
            text: 'text-10 text-accent flex items-center',
            icon: 'fill-accent w-16 h-16 mr-3',
        },
        topDeal: { text: 'text-10 text-accentOk flex items-center', icon: 'fill-accentOk w-16 h-16 mr-4' },
    },
    shadow: 'shadow-m060c010',
    shadowNarrow: 'shadow-m060c01Narrow',
    occassionProgramTag: {
        backgroundTheme: 'dark-bg',
        textTheme: 'dark-text',
    },
};

export const M060C010VehicleCardStyleOpel: M060C010VehicleCardStyleData = {
    brandName: 'OPEL',
    container: 'bg-light-bg border-1 border-grey-120 h-full',
    image: 'h-240 w-full object-cover',
    imageSizes: {
        desktop: { width: 360, height: 240 },
        tablet: { width: 360, height: 240 },
        moblie: { width: 360, height: 240 },
    },
    div: 'py-16 px-16',
    headline: 'font-bold text-24 text-light-text',
    modelTypeText: 'mb-10 text-14 ',
    badgeContainer: 'flex flex-wrap gap-6',
    badgeWrapper: 'bg-grey-180',
    badge: 'font-light text-light-text text-10 px-10 py-4 leading-12',
    actionTag: 'gap-6 mt-6',
    divider: 'border-0 border-transparent w-full max-w-75p',
    dividerDark: '',
    nextArrow: {
        container: 'hidden lg:flex left-md w-40 h-40 bg-light-bg shadow-sm justify-center items-center p-14',
        color: 'fill-light-text',
        size: '!w-40 !h-40',
        path: 'assets/icons/next.svg',
    },
    prevArrow: {
        container: 'hidden lg:flex left-md w-40 h-40 bg-light-bg shadow-sm justify-center items-center p-14',
        color: 'fill-light-text',
        size: '!w-40 !h-40',
        path: 'assets/icons/next.svg',
    },
    efficiency: '',
    consumptionAndEmission: 'text-grey-400 text-10 leading-14 tracking-0.25 mt-8',
    seller: {
        container: 'mt-16',
        copy: 'text-grey-400 text-10 leading-14 tracking-0.25 ml-4',
        iconPath: 'assets/icons/location.svg',
        iconStyle: 'fill-grey-400 w-8 h-8',
    },
    skeleton: {
        headline: 'h-36 w-100 bg-grey-100',
        modelTypeText: 'mb-10 h-21 w-100 bg-grey-100',
        priceValueDark: 'bg-dark-bg',
        priceValueLight: 'bg-light-bg',
        priceContainerDark: 'bg-accent-bg',
        priceContainerLight: 'bg-light-bg',
    },
    hardselling: {
        tag: '',
        topVehicle: {
            text: 'text-12 leading-16 text-accent flex items-center mb-4',
            icon: 'fill-accentWarn w-24 h-24',
        },
        topDeal: { text: 'text-12 leading-16 text-accentOk flex items-center', icon: 'fill-accentOk w-24 h-24' },
    },
    shadow: '',
    shadowNarrow: '',
    occassionProgramTag: {
        backgroundTheme: 'dark-bg',
        textTheme: 'dark-text',
    },
};

export const M060C010VehicleCardStyleLexus: M060C010VehicleCardStyleData = {
    brandName: 'LEXUS',
    container: 'bg-light-bg h-full',
    image: 'h-205 w-full object-cover',
    imageSizes: {
        desktop: { width: 360, height: 240 },
        tablet: { width: 360, height: 240 },
        moblie: { width: 360, height: 240 },
    },
    div: 'px-24 lg:px-40 pt-40 pb-24',
    headline: 'text-20 lg:text-24 leading-28 lg:leading-32 tracking-1.5 text-light-text',
    modelTypeText: 'mb-16 text-14 leading-22 text-medium-text tracking-2',
    badgeContainer: 'flex flex-wrap gap-8 items-center',
    badgeWrapper: 'bg-grey-100',
    badge: 'font-book rounded-full overflow-hidden text-light-text leading-10 text-12 px-12 py-4 tracking-0.1',
    actionTag: 'gap-8 mt-8',
    divider: '',
    dividerDark: 'ml-40 h-1 bg-medium-bg w-30',
    nextArrow: {
        container:
            'hidden lg:flex left-md w-40 h-40 bg-light-bg shadow-sm justify-center items-center p-14 rounded-full',
        color: 'stroke-light-text',
        size: '!w-40 !h-40',
        path: 'assets/icons/chevron_right.svg',
    },
    prevArrow: {
        container:
            'hidden lg:flex left-md w-40 h-40 bg-light-bg shadow-sm justify-center items-center p-14 rounded-full',
        color: 'stroke-light-text',
        size: '!w-40 !h-40',
        path: 'assets/icons/chevron_right.svg',
    },
    efficiency: '',
    consumptionAndEmission: 'text-grey-400 font-book text-12 leading-14 tracking-0.1 mt-8',
    seller: {
        container: 'mt-16',
        copy: 'text-grey-400 font-book text-12 leading-14 tracking-0.1 ml-6',
        iconPath: 'assets/icons/location.svg',
        iconStyle: 'fill-grey-400 w-16 h-16 -ml-2',
    },
    skeleton: {
        headline: 'h-36 w-100 bg-grey-100',
        modelTypeText: 'mb-10 h-21 w-100 bg-grey-100',
        priceValueDark: 'bg-dark-bg',
        priceValueLight: 'bg-light-bg',
        priceContainerDark: 'bg-accent-bg',
        priceContainerLight: 'bg-light-bg',
    },
    hardselling: {
        tag: 'bg-white-70 rounded-full px-6',
        topVehicle: {
            text: 'text-12 leading-20 text-accentWarn flex items-center',
            icon: 'fill-accentWarn w-16 h-16',
        },
        topDeal: { text: 'text-12 leading-20 text-accentOk flex items-center', icon: 'fill-accentOk w-16 h-16' },
    },
    shadow: '',
    shadowNarrow: '',
    occassionProgramTag: {
        backgroundTheme: 'dark-bg',
        textTheme: 'dark-text',
    },
};

export const M060C010VehicleCardStyleLandRover: M060C010VehicleCardStyleData = {
    brandName: 'LAND_ROVER',
    container: 'bg-white h-full min-h-490',
    image: 'h-240 w-full object-cover',
    imageSizes: {
        desktop: { width: 360, height: 240 },
        tablet: { width: 360, height: 240 },
        moblie: { width: 360, height: 240 },
    },
    div: 'pb-8 pt-16 px-16',
    headline: 'text-20 leading-24 text-light-text font-bold uppercase',
    modelTypeText: 'font-secondary mb-32 mt-4 text-14 font-medium leading-18 text-grey-400 h-18',
    badgeContainer: 'flex flex-wrap gap-8 items-center',
    badgeWrapper: '',
    badge: 'font-secondary rounded-4 overflow-hidden border-grey-border border-1 text-light-text text-11 leading-14 px-8 py-5 ',
    actionTag: 'gap-8 mt-8',
    divider: '',
    dividerDark: 'ml-40 h-1 bg-medium-bg w-30',
    nextArrow: {
        container: 'flex left-md w-65 h-65 bg-transparent  justify-center items-center p-10 rounded-full',
        color: 'fill-white',
        size: '!w-65 !h-65',
        path: 'assets/icons/chevron_right.svg',
    },
    prevArrow: {
        container: 'flex left-md w-65 h-65 bg-transparent  justify-center items-center p-10 rounded-full',
        color: 'fill-white',
        size: '!w-65 !h-65',
        path: 'assets/icons/chevron_right.svg',
    },
    efficiency: '',
    skeleton: {
        headline: 'h-36 w-100 bg-grey-100',
        modelTypeText: 'mb-10 h-21 w-100 bg-grey-100',
        priceValueDark: '',
        priceValueLight: 'bg-light-bg',
        priceContainerDark: 'bg-black',
        priceContainerLight: 'bg-light-bg',
    },
    hardselling: {
        tag: 'bg-white-70 rounded-full px-6',
        topVehicle: {
            text: 'text-12 leading-20 text-accentWarn flex items-center',
            icon: 'fill-accentWarn w-16 h-16',
        },
        topDeal: { text: 'text-12 leading-20 text-accentOk flex items-center', icon: 'fill-accentOk w-16 h-16' },
    },
    shadow: '',
    shadowNarrow: 'shadow-narrow',
    consumptionAndEmission: 'font-secondary text-grey-400 text-11 leading-14 mt-8',
    seller: {
        container: 'mt-16',
        copy: 'font-secondary text-grey-400 text-11 leading-14 ml-5',
        iconPath: 'assets/icons/location.svg',
        iconStyle: 'fill-grey-400 w-12 h-12 -ml-2',
    },
    hiddePirceArrow: false,
    occassionProgramTag: {
        backgroundTheme: 'accent-bg',
        textTheme: 'accent-text',
        customTagIconColorClass: 'fill-dark-text',
        customBackgroundClass: 'bg-approved-grey',
        customTagTextColorClass: 'text-dark-text',
        disableBorder: true,
        disableInfo: false,
    },
};

export const M060C010VehicleCardStyleJaguar: M060C010VehicleCardStyleData = {
    brandName: 'JAGUAR',
    container: 'bg-light-bg h-full shadow-sm',
    image: 'h-240 w-full object-cover',
    imageSizes: {
        desktop: { width: 360, height: 240 },
        tablet: { width: 360, height: 240 },
        moblie: { width: 360, height: 240 },
    },
    div: 'px-16 pt-16 pb-8 ',
    headline: 'text-20 leading-24 font-bold uppercase',
    modelTypeText: 'mb-32 text-14 font-semibold leading-18 mt-4 h-18',
    badgeContainer: 'flex flex-wrap gap-8 items-center mb-8',
    badgeWrapper: '',
    badge: 'font-book rounded-5 overflow-hidden border-grey-250 border-1 text-light-text text-13 px-12 py-4 ',
    actionTag: 'gap-8',
    divider: 'h-1 mx-16 bg-grey-250',
    dividerDark: '',
    nextArrow: {
        container: 'flex left-md w-65 h-65 bg-transparent  justify-center items-center p-0 rounded-full',
        color: 'fill-white',
        size: '!w-48 !h-48',
        path: 'assets/icons/chevron_right.svg',
    },
    prevArrow: {
        container: 'flex left-md w-65 h-65 bg-transparent  justify-center items-center p-0 rounded-full',
        color: 'fill-white',
        size: '!w-48 !h-48',
        path: 'assets/icons/chevron_right.svg',
    },
    efficiency: '',
    skeleton: {
        headline: 'h-36 w-100 bg-grey-100',
        modelTypeText: 'mb-10 h-21 w-100 bg-grey-100 mt-4',
        priceValueDark: 'bg-dark-bg',
        priceValueLight: 'bg-light-bg',
        priceContainerDark: 'bg-accent-bg',
        priceContainerLight: 'bg-light-bg',
    },
    hardselling: {
        tag: 'bg-white-70 rounded-full px-6',
        topVehicle: {
            text: 'text-12 leading-20 text-accentWarn flex items-center',
            icon: 'fill-accentWarn w-16 h-16',
        },
        topDeal: { text: 'text-12 leading-20 text-accentOk flex items-center', icon: 'fill-accentOk w-16 h-16' },
    },
    shadow: '',
    shadowNarrow: '',
    occassionProgramTag: {
        backgroundTheme: 'accent-bg',
        textTheme: 'accent-text',
        customTagIconColorClass: 'fill-dark-text',
        customBackgroundClass: 'bg-accent-bg',
        customTagTextColorClass: 'text-dark-text',
        disableInfo: false,
    },
    consumptionAndEmission: 'text-grey-450 text-11 leading-13 mt-8',
    seller: {
        container: 'mt-16',
        copy: 'text-grey-450 text-11 leading-13 ml-2',
        iconPath: 'assets/icons/location.svg',
        iconStyle: 'fill-grey-450 w-12 h-12 -ml-2',
    },
};

export const M060C010VehicleCardStyleKia: M060C010VehicleCardStyleData = {
    brandName: 'KIA',
    container: 'bg-light-bg h-full shadow-card',
    image: 'h-240 w-full object-cover',
    imageSizes: {
        desktop: { width: 360, height: 240 },
        tablet: { width: 360, height: 240 },
        moblie: { width: 360, height: 240 },
    },
    div: 'p-16 pb-12',
    headline: 'font-semibold leading-30 text-24 text-light-text',
    modelTypeText: 'mb-20 text-16 leading-22 text-grey-400',
    badgeContainer: 'flex flex-wrap gap-8',
    badgeWrapper: 'bg-grey-100 h-24 px-10',
    badge: 'text-light-text text-10 leading-10',
    actionTag: 'gap-8 mt-8',
    divider: 'border-0 border-transparent w-full max-w-75p',
    dividerDark: '',
    nextArrow: {
        container:
            'hidden bg-[#05141F33] lg:flex left-md size-40 shadow-sm justify-center items-center p-14 rounded-full',
        color: 'fill-white',
        size: '',
        path: 'assets/icons/arrow_right.svg',
    },
    prevArrow: {
        container:
            ' hidden bg-[#05141F33]  lg:flex left-md size-40 shadow-sm justify-center items-center p-14 rounded-full',
        color: 'fill-white',
        size: '',
        path: 'assets/icons/arrow_right.svg',
    },
    efficiency: '',
    consumptionAndEmission: 'text-grey-400 text-10 leading-17 mt-16',
    skeleton: {
        headline: 'h-36 w-100 bg-grey-100',
        modelTypeText: 'mb-10 h-21 w-100 bg-grey-100',
        priceValueDark: 'bg-dark-bg',
        priceValueLight: 'bg-light-bg',
        priceContainerDark: 'bg-dark-bg',
        priceContainerLight: 'bg-light-bg',
    },
    hardselling: {
        tag: '',
        topVehicle: {
            text: 'text-12 leading-16 text-accent flex items-center mb-4',
            icon: 'fill-accentWarn w-24 h-24',
        },
        topDeal: { text: 'text-12 leading-16 text-accentOk flex items-center', icon: 'fill-accentOk w-24 h-24' },
    },
    shadow: '',
    shadowNarrow: '',
    occassionProgramTag: {
        backgroundTheme: 'accent-bg',
        textTheme: 'accent-text',
        customTagIconColorClass: 'fill-accent-text',
        customBackgroundClass: 'bg-accent-bg',
        customTagTextColorClass: 'text-accent-text',
        disableInfo: true,
    },
    seller: {
        container: 'mt-16 -mb-7',
        copy: 'text-grey-450 text-11 leading-13 ml-2',
        iconPath: 'assets/icons/location.svg',
        iconStyle: 'fill-grey-450 w-12 h-12 -ml-2',
    },
};

export const M060C010VehicleCardStyleSuzuki: M060C010VehicleCardStyleData = {
    brandName: 'SUZUKI',
    container: 'bg-light-bg h-full',
    image: 'h-240 min-w-350 xs:min-w-365 md:min-w-480 lg:min-w-338 w-full object-cover',
    imageSizes: {
        desktop: { width: 360, height: 240 },
        tablet: { width: 360, height: 240 },
        moblie: { width: 360, height: 240 },
    },
    div: 'py-16 px-16',
    headline: 'font-semibold text-18 text-light-text',
    modelTypeText: 'mt-3 mb-24 text-12',
    badgeContainer: 'flex flex-wrap gap-8',
    badgeWrapper: 'bg-grey-100',
    badge: 'text-light-text text-10 px-10 py-4 leading-14 tracking-0.1',
    actionTag: 'gap-8 mt-8 mb-16',
    divider: '',
    dividerDark: '',
    nextArrow: {
        container: 'hidden lg:flex left-md w-40 h-40 justify-center items-center',
        color: 'fill-dark-text',
        size: '!w-20 !h-20',
        path: 'assets/icons/chevron_right.svg',
    },
    prevArrow: {
        container: 'hidden lg:flex left-md w-40 h-40 justify-center items-center',
        color: 'fill-dark-text',
        size: '!w-20 !h-20',
        path: 'assets/icons/chevron_right.svg',
    },
    efficiency: '',
    consumptionAndEmission: 'text-grey-400 text-10 leading-14 tracking-0.25 mt-8',
    seller: {
        copy: 'text-grey-400 text-10 leading-14 tracking-0.25 ml-6',
        iconPath: 'assets/icons/location.svg',
        iconStyle: 'fill-grey-400 w-9 h-11',
    },
    skeleton: {
        headline: 'h-27 w-100 bg-grey-100',
        modelTypeText: 'mt-3 mb-24 h-18 w-100 bg-grey-100',
        priceValueDark: 'bg-dark-bg',
        priceValueLight: 'bg-light-bg',
        priceContainerDark: 'bg-light-bg',
        priceContainerLight: 'bg-dark-bg',
    },
    hardselling: {
        tag: 'bg-white-90 pr-5 pt-2 pb-4',
        topVehicle: {
            text: 'text-10 text-accent flex items-center',
            icon: 'fill-accent w-16 h-16 mr-3',
        },
        topDeal: { text: 'text-10 text-accentOk flex items-center', icon: 'fill-accentOk w-16 h-16 mr-4' },
    },
    shadow: 'shadow-m060c010',
    shadowNarrow: 'shadow-m060c01Narrow',
    occassionProgramTag: {
        backgroundTheme: 'dark-bg',
        textTheme: 'dark-text',
    },
};
export const M060C010VehicleCardStyleToken = new InjectionToken<M060C010VehicleCardStyleData>(
    'M060C010VehicleCardStyleToken',
);

export function provideM060C010VehicleCardStyleData(style: M060C010VehicleCardStyleData) {
    return {
        provide: M060C010VehicleCardStyleToken,
        useValue: style,
    };
}

export interface M060C010VehicleCardStyleData {
    brandName: string;
    container: string;
    image: string;
    imageSizes: {
        desktop: ImageSize;
        tablet: ImageSize;
        moblie: ImageSize;
    };
    div: string;
    headline: string;
    modelTypeText: string;
    badgeContainer: string;
    badgeWrapper: string;
    badge: string;
    actionTag: string;

    divider: string;
    dividerDark: string;
    nextArrow: {
        container: string;
        color: string;
        size: string;
        path?: string;
    };
    prevArrow: {
        container: string;
        color: string;
        size: string;
        path?: string;
    };
    efficiency: string;
    consumptionAndEmission: string;
    seller: {
        container?: string;
        copy: string;
        iconPath: string;
        iconStyle: string;
    };
    skeleton: {
        headline: string;
        modelTypeText: string;
        priceValueDark: string;
        priceValueLight: string;
        priceContainerDark: string;
        priceContainerLight: string;
    };
    hardselling: {
        tag: string;
        topVehicle: { text: string; icon: string };
        topDeal: { text: string; icon: string };
    };
    shadowNarrow: string;
    shadow: string;
    hiddePirceArrow?: boolean;
    occassionProgramTag: {
        backgroundTheme: string;
        textTheme: string;
        customTagIconColorClass?: string;
        customBackgroundClass?: string;
        customTagTextColorClass?: string;
        disableBorder?: boolean;
        disableInfo?: boolean;
    };
}
